/**
 * @file ScrollToTop.js
 * @description Scrolls to top on route changes so each page starts at the top.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollWindowToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  // Safari / legacy: ensure both roots move
  if (typeof document !== 'undefined') {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
}

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    scrollWindowToTop();
    // After layout/paint (images, fonts) so we beat late scroll restoration
    const id = window.requestAnimationFrame(() => {
      scrollWindowToTop();
    });
    return () => window.cancelAnimationFrame(id);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default ScrollToTop;
